__webpack_require__.p = "https://static.codametrix.ai/";